import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NopagefoundComponent } from './pages/nopagefound/nopagefound.component';
import { PagesRoutingModule } from './pages/pages-routing';


const routes: Routes = [

  { path: '', redirectTo: '/help', pathMatch: 'full' },

  { path: '**', component: NopagefoundComponent },


];

const isIframe = window !== window.parent && !window.opener;

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false,
      initialNavigation: !isIframe ? 'enabled' : 'disabled'
    }),
    PagesRoutingModule
  ],
  exports: [
    RouterModule,
  ]
})
export class AppRoutingModule {
}
